import { PageInfoDto } from '@/dto';
import { FIELDS } from './constants';

export let ShippingProvider = [
      FIELDS.ID,
    FIELDS.NAME ,
    FIELDS.ACTIVE,

];

export let ShippingProviderView = [
      FIELDS.ID,
    FIELDS.NAME,
    FIELDS.CREATED_BY_USER_ID,
    FIELDS.CREATED_BY_USER_FULL_NAME,
    FIELDS.MODIFIED_BY_USER_ID,
    FIELDS.MODIFIED_BY_USER_FULL_NAME,
    FIELDS.DATE_CREATED,
    FIELDS.DATE_MODIFIED,
    FIELDS.ACTIVE,

];

export class ShippingProviderListDto {
  constructor(results) {
    this.items = results.items.map(item => new gridDto(item));
    this.pageInfo = new PageInfoDto(results.paging);
  }
}

export class ShippingProviderDto {
  constructor(data = {}) {
    ShippingProvider.forEach(key => (this[key] = data[key] || null));
  }
}

export class gridDto {
  constructor(data = {}) {
    ShippingProviderView.forEach(key => (this[key] = data[key] || null));
  }
}
